<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "roles",
    cardSetLink: "roles",
    item: null,
    fields: [
      {
        label: 'Название роли',
        key: 'name',
        type: 'field',
      },

      {
        label: "Экраны",
        key: "sections",
        type: "selects",
        modal: "section",
        selectKey: "name",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
